import React from 'react';
import { Crop, RefreshCw } from 'lucide-react';

interface DiagramSectionProps {
  diagramImage?: string;
  onCrop: () => void;
  onRefresh?: () => void;
}

export const DiagramSection: React.FC<DiagramSectionProps> = ({
  diagramImage,
  onCrop,
  onRefresh,
}) => {
  return (
    <div>
      {diagramImage ? (
        <div className="mb-4">
          <img
            src={diagramImage}
            alt="Diagram Preview"
            className="max-w-full h-auto border border-gray-200 dark:border-gray-700 rounded"
          />
          <div className="mt-2 flex gap-2">
            <button
              onClick={onCrop}
              className="flex-1 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-transparent border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
            >
              <Crop className="inline-block mr-2 h-4 w-4" />
              Crop Diagram
            </button>
            {onRefresh && (
              <button
                onClick={onRefresh}
                className="flex-1 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-transparent border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
              >
                <RefreshCw className="inline-block mr-2 h-4 w-4" />
                Refresh Diagram
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="mb-4">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
            No diagram uploaded yet
          </p>
          <div className="flex gap-2">
            <button
              onClick={onCrop}
              className="flex-1 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-transparent border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
            >
              <Crop className="inline-block mr-2 h-4 w-4" />
              Crop Diagram
            </button>
            {onRefresh && (
              <button
                onClick={onRefresh}
                className="flex-1 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-transparent border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
              >
                <RefreshCw className="inline-block mr-2 h-4 w-4" />
                Refresh Diagram
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
